import React, { useState, useEffect, useMemo } from "react";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import UserTable from "./components/userTable/userTable";
import { Spinner } from "react-bootstrap";
import {
  Alert,
  Chip,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import "./userScreen.css";
import UserForm from "./components/userForm/userForm";
import SearchIcon from "@mui/icons-material/Search";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const UserScreen = () => {
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showSuspendPopup, setShowSuspendPopup] = useState(false);
  const [userToSuspendId, setUserToSuspendId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleAddForm = () => {
    setOpenForm(true);
    setSelectedUser(null);
    setIsEdit(false);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
  };

  const fetchUser = (page) => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/customer-users/`, config)
      .then((response) => {
        setUserList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("User Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleSubmit = (newUser) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("name", newUser.name);
    formData.append("phone", newUser.phone);
    formData.append("address", newUser.address);
    formData.append("location", newUser.location);

    axios
      .post(`${baseUrl}superadmin/user-create/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchUser();
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
        console.error("Error adding data:", error);
      });
  };

  const handleSuspendClose = () => {
    setShowSuspendPopup(false);
  };

  const handleOpenSuspend = (userId) => {
    setUserToSuspendId(userId);
    setShowSuspendPopup(true);
  };

  const handleSuspend = () => {
    if (!userToSuspendId) return;

    setLoading(true);

    const user = userList.find((u) => u.id === userToSuspendId);
    const isSuspended = user?.is_suspended ? "False" : "True";

    axios
      .post(
        `${baseUrl}auth/suspend-user/${userToSuspendId}/`,
        { is_suspended: isSuspended },
        {
          headers: {
            ...config.headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setLoading(false);
        fetchUser();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        handleSuspendClose();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error suspending user:", error);
      });
  };

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "User Id", width: 100 },
    { field: "name", headerName: "User Name", width: 200 },
    { field: "phone", headerName: "User Phone", width: 200 },
    { field: "address", headerName: "User Address", width: 200 },
    { field: "account_type", headerName: "User Type", width: 200 },
    {
      field: "is_suspended",
      headerName: "Account Status",
      width: 200,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Suspended" : "Active"}
          style={{
            backgroundColor: params.value ? "red" : "green",
            color: "white",
          }}
        />
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      width: 400,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color={params.row.is_suspended ? "success" : "error"}
            style={{ marginRight: "5px" }}
            onClick={() => handleOpenSuspend(params.row.id)}
          >
            {params.row.is_suspended ? "Active" : "Suspend"}
          </Button>
        </>
      ),
    },
  ];
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };


  const filteredUser = userList.filter((user) =>
    Object.entries(user).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue)
        );
      }
      if (typeof value === "boolean") {
      
        const booleanMap = {
          is_suspended: value ? "suspended" : "active",
        };
        return booleanMap[key]?.includes(searchValue);
      }
      return value?.toString().toLowerCase().includes(searchValue);
    })
  );
  
  

  const displayUser = searchValue ? filteredUser : userList;
  const paymentWithIndex = displayUser.map((payment, index) => ({
    ...payment,
    displayIndex: index + 1,
  }));


  return (
    <div className="user-main">
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <button className="btn-add-user" onClick={handleAddForm}>
            Add User Details
          </button>
          <div className="search-container d-flex justify-content-center my-2">
            <TextField
              id="search"
              name="search"
              className="search-field"
              placeholder="Search here..."
              value={searchValue}
              onChange={handleSearchChange}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "transparent" },
                  "&:hover fieldset": { borderColor: "transparent" },
                  "&.Mui-focused fieldset": { borderColor: "transparent" },
                },
              }}
            />
          </div>
          <UserTable userList={paymentWithIndex} columns={columns} />
          <UserForm
            open={openForm}
            onClose={handleCloseForm}
            user={isEdit ? selectedUser?.row : null}
            onSubmit={handleSubmit}
          />

          <Dialog
            open={showSuspendPopup}
            onClose={() => setShowSuspendPopup(false)}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Confirm Action</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {userList.find((u) => u.id === userToSuspendId)?.is_suspended
                  ? "Do you want to activate this user?"
                  : "Do you want to suspend this user?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                size="small"
                color={
                  userList.find((u) => u.id === userToSuspendId)?.is_suspended
                    ? "primary"
                    : "error"
                }
                style={{ textTransform: "none" }}
                onClick={handleSuspend}
              >
                {userList.find((u) => u.id === userToSuspendId)?.is_suspended
                  ? "Activate"
                  : "Suspend"}
              </Button>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                  color: "grey",
                  outline: "1px solid grey",
                }}
                onClick={handleSuspendClose}
              >
                cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default UserScreen;
